import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { finalize, Subject, Subscription, takeUntil } from 'rxjs';
import { baseAttachDto, SingleResponseModel } from 'src/app/tabms/models/base/base';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FileUploadControl, FileUploadValidators } from '@iplab/ngx-file-upload';
import { BaseAttachService } from 'src/app/tabms/services/base/base-attach.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-base-attach',
  templateUrl: './base-attach.component.html',
  styleUrl: './base-attach.component.scss'
})
export class BaseAttachComponent implements OnInit, OnDestroy {
  @Input()
  requiredFileType: string;

  fileName = '';
  uploadProgress: number;
  uploadSub: Subscription;
  attachedFiles;
  systemMenuId;
  recordId;
  meneuKey: string;
  pageParameters: string;

  private destroy$: Subject<void> = new Subject<void>();

  private filesControl = new UntypedFormControl(null, FileUploadValidators.filesLimit(10));
  demoForm = new UntypedFormGroup({
    files: this.filesControl
  });

  @ViewChild('fileUpload') fileUploadComponent: any;
  currentLang;

  constructor(
    private http: HttpClient,
    private baseAttachService: BaseAttachService,
    @Inject(MAT_DIALOG_DATA) public data,
    private baseService: BaseService,
    private dialogRef: MatDialogRef<BaseAttachComponent>,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
  ) {
    this.systemMenuId = data.systemMenuId;
    this.recordId = data.id;
    this.meneuKey = data.menuKey;
    this.pageParameters = data.pageParameter;
    this.currentLang = this.translate.currentLang;

  }
  ngOnInit(): void {
    this.getFiles();
  }

  ngAfterViewInit() {
    // console.log(this.fileUploadComponent);
  }

  onFileSelected(event) {
    //const file: File = event.target.files[0];
    let files: File[] = this.demoForm.value.files;
    if (files?.length > 0) {
      files.forEach((file, index) => {
        if (file) {
          this.fileName = file.name;
          const formData = new FormData();
          formData.append("file", file);

          this.baseAttachService.create(formData, this.fileName, this.recordId, this.meneuKey, this.pageParameters)
            .pipe(
              finalize(() => this.reset()), takeUntil(this.destroy$)
            ).subscribe({
              next: (res) => {
                if (res && res['body']) {
                  this.baseService.showSuccessMessage('File Saved Successfuly');
                  if (files.length - 1 == index) {
                    files = [];
                    // const fileInput = <HTMLInputElement>document.querySelector('ngx-mat-file-input[formcontrolname="file"] input[type="file"]');
                    // console.log(fileInput);
                    // const fileInput = <HTMLInputElement>document.querySelector('upload-list');
                    // console.log(fileInput);
                    // fileInput.value = null;
                    // this.fileUploadComponent.control.files.clear();
                    // this.fileUploadComponent.control.listVisible = false;
                    // this.demoForm.get('files')?.reset();
                      // فضي الكنترول بطريقة آمنة
                      this.demoForm.get('files')?.setValue([]);
                      this.demoForm.get('files')?.markAsPristine();
                      this.demoForm.get('files')?.markAsUntouched();

                      // ماتنشئش FileUploadControl جديد هنا 👇
                      // this.fileUploadComponent.control = new FileUploadControl(); ❌

                      this.cdr.detectChanges();
                      this.getFiles();
                      this.baseService.refreshTable.next(true);
                  }
                }
              },
              error: (err) => {
                this.baseService.showErrorMessage('Operation Failed');
              }
            });
        }
      });
    } else {
      this.baseService.showInfoMessage('NoFilesSelected');
    }
  }

  cancelUpload() {
    this.uploadSub.unsubscribe();
    this.reset();
  }

  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;
  }

  getFiles() {
    this.baseAttachService.GetFileDataWithStream(this.meneuKey, this.pageParameters, this.recordId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res && res.result) {
          this.attachedFiles = res.result;
        }
      },
      error: (err) => {
      }

    });
  }

  delete(fileId) {
    this.baseAttachService.deleteFile(fileId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.getFiles();
        this.baseService.showSuccessMessage('File Deleted Successfuly');
      },
      error: (err) => {
        this.baseService.showErrorMessage('Operation Failed');
      }
    });
  }

  download(task: baseAttachDto) {

    // const link = document.createElement('a');
    // link.href = `data:application/pdf;base64,${task.stream}`;
    // link.download = task.name;
    // link.click();

    // Base64 to byte array
    const byteCharacters = atob(task.stream); // decode base64
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Create blob
    const blob = new Blob([byteArray]);

    // Create download link
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${task.name}.${task.ext}`;
    link.click();

  }

  /*  url;
   preview(task) {
     var reader = new FileReader();
     reader.readAsDataURL(task); // read file as data url
     reader.onload = (event) => { // called once readAsDataURL is completed
       this.url = event.target.result;
     }
   } */

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
